import { render, staticRenderFns } from "./LsvaTrailersTable.vue?vue&type=template&id=179a8cc7&scoped=true&"
import script from "./LsvaTrailersTable.vue?vue&type=script&lang=js&"
export * from "./LsvaTrailersTable.vue?vue&type=script&lang=js&"
import style0 from "./LsvaTrailersTable.vue?vue&type=style&index=0&id=179a8cc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a8cc7",
  null
  
)

/* custom blocks */
import block0 from "./LsvaTrailersTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports